module.exports = __webpack_public_path__ + "img/ComunicacionEquipoEnActivacion.c48260f3.svg";